import { useApolloClient } from '@apollo/client';
import { usePostHog } from 'posthog-js/react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useMessage } from '@/modules/common/application/context/message';
import { removeLocalStorage } from '@/modules/common/application/localstorage';
import { localStorageKeys } from '@/modules/common/types/localstorage';
import { logoutUser } from '@/services/auth.service';
import { cachePersistor } from '@/services/graphql/cache';

export default function useLogout() {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const posthog = usePostHog();
  const navigate = useNavigate();
  const { setErrorMessage } = useMessage();
  const client = useApolloClient();

  const logout = useCallback(
    async (tenantId?: string) => {
      setLoading(true);
      try {
        await logoutUser(tenantId ?? null);

        if (client) {
          await client.clearStore();
        }

        if (cachePersistor) {
          await cachePersistor.purge();
        }
        removeLocalStorage(localStorageKeys.i18nextLng);

        posthog?.reset();

        navigate('/login');
      } catch (error) {
        console.error('error', error);
        setErrorMessage(t('messages.logout.error'));
      } finally {
        setLoading(false);
      }
    },
    [setErrorMessage, t, posthog, navigate, client]
  );

  return { logout, loading };
}
